import React from 'react';
import { Link } from 'react-router-dom';
import { MenuItem } from 'react-bootstrap';

const NavBarLink = ({
  to,
  label,
  condition = true,
  permission = true,
  divider = false,
  children,
}) => {
  if (!condition || !permission) {
    return null;
  }

  if (divider) {
    return <MenuItem divider />;
  }

  return (
    <li>
      <Link to={to}>{label || children}</Link>
    </li>
  );
};

export default NavBarLink;
